// src/hooks/useTicketExport.ts
import axios from "axios";
import { toast } from "react-toastify";
import { API_BASE_PATH } from "../../environment";

const TICKET_BASE_URL = API_BASE_PATH;

// ====== Error Extractor ======
const extractErrorMessage = (error: any) => {
  const detail = error?.response?.data?.detail;
  let details = error?.response?.data?.details;
  const message = error?.response?.data?.message;

  if (typeof details === "string") {
    details = details.replace(/^\d+\s*:\s*/, ""); // strip numeric codes
  }

  return detail || details || message;
};

// Export Single Ticket as Excel
export const exportSingleTicketExcel = async (ticketId: string,token: string | null) => {
  try {
    if (!ticketId) {
      toast.warning("No ticket ID provided to export.");
      return;
    }

    const response = await axios.get(
      `${TICKET_BASE_URL}/tickets/export_excel/selected/data/?ticket_id=${ticketId}`,
      {
        headers: { accept: "application/json",Authorization: `Bearer ${token}`, },
        responseType: "blob",
      }
    );

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Ticket_${ticketId}.xlsx`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
    toast.success("Ticket Excel downloaded successfully.");
  } catch (error: any) {
    console.error("Export single ticket Excel failed:", error);
    const msg = extractErrorMessage(error);
    toast.error(msg);
  }
};

// Export All Tickets as Excel
export const exportAllTicketsExcel = async (token: string | null) => {
  try {
    const response = await axios.get(
      `${TICKET_BASE_URL}/tickets/export_to_excel`,
      {
        headers: { accept: "application/json",Authorization: `Bearer ${token}`, },
        responseType: "blob",
      }
    );

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "All_Tickets.xlsx";
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
    toast.success("All tickets Excel downloaded successfully.");
  } catch (error: any) {
    console.error("Export all tickets Excel failed:", error);
    const msg = extractErrorMessage(error);
    toast.error(msg);
  }
};
